import React, { Component } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { Link, withRouter } from "react-router-dom";

import "../../scss/pages/auth.scss"
import { userLogin, userLoginFb } from "../../network/auth.network";
import { connect } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.action";
import localization from '../../Localization/Localization.json'
import logo from "../../assets/Logo.svg"
import FacebookLogin from 'react-facebook-login';
import { clearCart } from "../../redux/cart/cart.action";

// import TiSocialFacebookCircular from 'react-icons/lib/ti/social-facebook-circular';

class Login extends Component {
  constructor() {
    super();
    this.state = {
      btnLoading: false,
      isLoginValid: false,
    };
  }

 responseFacebook = (response) => {
    console.log(response);
    if(response){
      this.setState({btnLoading : true})
      let body = new FormData();
      body.append("first_name", response.name);
      body.append("last_name", "");
      body.append("email", response.email);
      body.append("provider", "FACEBOOK");
      body.append("providerId", response.id);
      userLoginFb(
        body,
        (res) => {
          this.setState({btnLoading : false})
          console.log(res); 
          if(res.data.code === 200){
              localStorage.setItem('token', res.data.message); 
              this.props.dispatch(setCurrentUser({...res.data.data.user, token : res.data.message})) 
              this.props.dispatch(clearCart());   
              setTimeout(() => {
                  this.props.history.push("/"); 
              }, 500) 
          }
          if(res.data.code === 105){
              setTimeout(() => {
                this.props.history.push({ 
                  pathname: '/phone-verification',
                  state: { user_id: res.data.item } 
                })
            }, 200)
          }
        },
        (error) => {
          console.log(error);  
          this.setState({btnLoading : false})
        }
      );
    }
  }
  onFinish = (values) => {
    this.setState({btnLoading : true})
    let body = new FormData();
    body.append("username", values.username);
    body.append("password", values.password);
    userLogin(
      body,
      (res) => {
        this.setState({btnLoading : false})
        if(res.data.code === 200){
            localStorage.setItem('token', res.data.message); 
            this.props.dispatch(setCurrentUser({...res.data.data.user, token : res.data.message}))  
            this.props.dispatch(clearCart());  
            setTimeout(() => {
                this.props.history.push("/"); 
            }, 500)  
        }
        if(res.data.code === 105){
            setTimeout(() => {
              this.props.history.push({  
                pathname: '/phone-verification',
                state: { user_id: res.data.item, user_phone : res.data.message } 
              })
          }, 200)
        }
      },
      (error) => {
        console.log(error);  
        this.setState({btnLoading : false})
      }
    );
    
  };
  
  render() {
    const { btnLoading, isLoginValid } = this.state;
    const { currentLang } = this.props; 
    return ( 
      <div>
        <div className="auth-wrapper">
          <div className="auth-form-content">
              <Link to="/" className="logo-holder">
                <img src={logo} alt="logo" />
              </Link>
              <p className="form-welcom">
              {localization.Welcome[currentLang]}
              </p>
              <p className="login-text">{localization.Loginaccount[currentLang]}</p>
              <p className="user-text">{localization.NewUser[currentLang]}<Link to="/register">{localization.Createaccount[currentLang]}</Link> </p>
            <Form
              name="basic" 
              onFinish={this.onFinish}  
            >
              <Form.Item
                label={localization.EmailAddress[currentLang]}
                name="username"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
                className="input-holder"
              >
                <Input />
              </Form.Item>

              <Form.Item
                label={localization.Password[currentLang]}
                name="password"
                className="input-holder"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password />
              </Form.Item>
                <Link className="forget-link" to="">{localization.Forgetpassword[currentLang]}</Link>
                <Button size="large" type="primary" htmlType="submit" block loading={btnLoading}>
                  {localization.Signin[currentLang]}
                </Button>

                <div className="facebook-login-holder">
                  <p>{localization.Orlogin[currentLang]}</p>  
                  <FacebookLogin 
                  appId="851655875731830" 
                  // appId="136578575225554" 
                  fields="name,email,picture"
                  cssClass="my-facebook-button-class"
                  textButton =""
                  icon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                      <g transform="translate(0.5 0)">
                          <rect width="48" height="48" fill="#3b5998" rx="24" transform="translate(-0.5 0)"/>
                          <path fill="#fff" d="M15.059 15.239h2.878l1.151-4.6h-4.029v-2.3c0-1.186 0-2.3 2.3-2.3h1.727V2.161A32.426 32.426 0 0 0 15.8 2c-3.126 0-5.345 1.908-5.345 5.411v3.223H7v4.6h3.454v9.785h4.6z" transform="translate(11 10.5)"/>
                      </g>
                  </svg>} 
                  callback={this.responseFacebook}
                  />
                </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
}) 

const LoginWithRouter = withRouter(Login);
export default connect(mapStateToProps)(LoginWithRouter);
